<!--点位对象 属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? name + '-' + pointDataName : '新建：' + pointDataName" :has-form="true" class="my-test-class"
      @close="close" @confirm="handleConfirm">
      <!-- <div>
        <a
          class="gs-modal-close"
          style="left: 86%;top: 12px"
          @click="dialogHelp = true"
        >
          <i
            class="el-icon-question"
            style="font-size: 17px;color: #737373"
          ></i>
        </a>
      </div> -->
      <gs-form :model="form" label-width="60px" label-position="left" gap="small">
        <gs-form-item
          v-if="!('AnalogInput,AnalogOutput,value_Analog,value_Multistate,BinaryInput,BinaryOutput,value_Binary,value_String').includes(nodeData.type) || (nodeData.attribute && nodeData.attribute.pointType)"
          label="名称" prop="target" class="form-item-radio">
          <gs-input ref="nameInput" v-model="name" />
        </gs-form-item>
        <gs-form-item label="描述" prop="target" class="form-item-radio">
          <gs-input v-model="description" />
        </gs-form-item>
        <!-- <gs-form-item
          v-if="pointData"
          label="值"
          prop="target"
          class="form-item-radio"
        >
          <gs-input
            v-if="pointData.type==='Analog' || pointData.type==='Multistate' || pointData.type==='String'"
            v-model="value"
          />
          <gs-select
            v-if="pointData.type==='Binary'"
            v-model="value"
          >
            <gs-option
              v-for="(i,index) in binaryArray"
              :key="index"
              :label="i.label"
              :value="i.value"
            />
          </gs-select>
        </gs-form-item> -->
        <gs-form-item v-if="pointData.type !== 'String'" label="单位" prop="target" class="form-item-radio">
          <gs-input v-model="canValue" />
        </gs-form-item>
        <!--<gs-form-item
          v-if="pointData.type!=='String'"
          label="设备信息"
          prop="target"
          class="form-item-radio"
        >
          <gs-input
            v-model="deviceMessage"
          />
        </gs-form-item>-->
        <gs-form-item v-if="pointData.type !== 'String'" label="计算公式" prop="target" class="form-item-radio">
          <gs-input v-model="expression" />
        </gs-form-item>
        <!--  <gs-form-item
          label="报警状态"
          prop="target"
          class="form-item-radio"
        >
          <gs-select
            :disabled="false"
            v-model="form.din"
          >
            <gs-option
              label="正常"
              value="正常"
            />
            <gs-option
              label="报警"
              value="报警"
            />
          </gs-select>
        </gs-form-item> -->
        <!-- <gs-form-item
          v-if="pointData.isEdit && nodeData.attribute && !nodeData.attribute.pointType"
          label="强制操作"
          prop="target"
          class="form-item-radio"
        >
          <gs-checkbox v-model="force" />
        </gs-form-item> -->
      </gs-form>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <gs-button type="primary" size="mini" @click="dialogHelp = true">帮 助</gs-button>
      </span>
    </gs-modal>
    <gs-modal title="帮助-模拟量" v-model="dialogHelp" class="my-test-class" :before-close="handleCloseHelp">
      <span class="tit">描述：</span><span class="txt">该数据的详细描述</span><br>
      <span class="tit">值：</span><span class="txt">数据的当前值</span><br>
      <span class="tit">单位：</span><span class="txt">数据单位</span><br>
      <span class="tit">计算公式：</span><span class="txt">a为当前点位原始值，公式例如：a*10-5、a/10</span><br>
      <span class="tit">报警状态：</span><span class="txt">设定数据的报警状态</span><br>
      <span class="tit">强制操作：</span><span class="txt">强制操作该数据</span><br>
      <!--<el-button @click="dialogHelp = false">取 消</el-button>
      <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->
    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
export default {
  components: {

  },
  data() {
    return {
      dialogHelp: false,
      isEdit: false, // 对象的状态,0表示新建,1表示属性
      loading: false,
      activeName: 'first',
      form: {
      },
      checked: '',
      tableData: [],
      description: '',
      Din: '',
      name: '',
      binaryArray: [
        { label: 0, value: 0 },
        { label: 1, value: 1 }
      ],
      canValue: '',
      force: false,
      value: 0,
      deviceMessage: '',
      expression: ''
    }
  },
  computed: {
    ...mapState({
      visible: 'pointShow',
      nodeData: 'objectInfo',
      pointData: 'pointData'
    }),
    pointDataName() {
      switch (this.pointData.type) {
        case 'Analog':
          return '值-模拟量'
        case 'Binary':
          return '值-二进制'
        case 'Multistate':
          return '值-多态'
        case 'String':
          return '字符串数据'
        default:
          break
      }
    }
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData
    },
    nodeData() {

    },
    visible() {
      if (this.visible) {
        /*  setTimeout(() => {
            this.$refs.nameInput.focus()
          }, 100)*/
      }
    },
    pointData() {
      this.canValue = ''
      if (JSON.stringify(this.nodeData) !== '{}' && this.checktype() && this.pointData.isEdit) {
        this.form = this.nodeData.attribute ? this.nodeData.attribute : {}
        this.description = this.nodeData.description ? this.nodeData.description : ''
        this.value = this.nodeData.value ? this.nodeData.value : 0
        this.name = this.nodeData.name ? this.nodeData.name : ''
        this.force = this.nodeData.attribute.force ? this.nodeData.attribute.force : false
        this.isEdit = true
        this.expression = this.nodeData.attribute.expression
        service.getNode(this.nodeData.id).then(res => {
          this.form = res.attribute
          this.description = res.description
          this.name = res.name
          this.value = res.value
          this.force = res.attribute.force
          this.expression = res.attribute.expression
        })
        // if (this.pointData.isEdit) {

        // } else {
        // this.form = {}
        // this.description = ''
        // this.name = ''
        // }
      } else {
        this.form = {}
        this.description = ''
        this.name = ''
        this.value = 0
        this.isEdit = false
      }
      if (this.pointData.type === 'Analog') {
        this.canValue = this.nodeData.unit
      }
      if (this.pointData.type === 'Binary') {
        this.canValue = this.nodeData.unit
      }
      if (this.pointData.type === 'Multistate') {
        this.canValue = this.nodeData.unit
      }
      if (this.pointData.type === 'String') {
        this.canValue = this.nodeData.unit
      }
    }
  },
  methods: {
    ...mapMutations({
      close: 'POINT_HIDE',
      needReload: 'NEED_RELOAD_TREE'
    }),
    handleCloseHelp() {
      this.dialogHelp = false
    },
    beforeClose() {
      this.close()
    },
    checktype() {
      let checkMark = false
      if (this.pointData.type === 'Analog') {
        checkMark = true
      }
      if (this.pointData.type === 'Binary') {
        checkMark = true
      }
      if (this.pointData.type === 'Multistate') {
        checkMark = true
      }
      if (this.pointData.type === 'String') {
        checkMark = true
      }
      return checkMark
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      this.loading = true
      console.log(this.nodeData, "111111111111111111")
      if (this.pointData.isEdit === true) {
        if (this.nodeData.attribute && this.nodeData.attribute.pointType) {
          let uploadData = {
            'id': this.nodeData.id, // 点位id
            'name': this.name, // 点位名称
            'type': this.nodeData.type, // 点位类型,八种中的一种
            'parentId': this.nodeData.parentId,
            'fullName': this.nodeData.fullName,
            'value': this.value,
            'unit': this.canValue,
            'description': this.description,
            'mqttId': this.nodeData.mqttId,
            'keyPrefix': this.nodeData.keyPrefix,
            'sort': this.nodeData.sort,
            'attribute': {
              'alarmState': '正常', // 报警状态
              'settableValue': this.canValue, // 可设置的值或单位
              'expression': this.expression,
              pointType: true,
            }
          }
          service.renamePoint(uploadData).then(res => {
            this.loading = false
            this.$Message.success('修改成功')
          }).catch(err => {
            this.loading = false
            this.$Message.error(err.message)
          })
        } else {
          let data = {
            'id': this.nodeData.id, // 点位id
            'name': this.nodeData.name, // 点位名称
            'type': this.nodeData.type, // 点位类型
            'parentId': this.nodeData.parentId,
            'value': this.value,
            'fullName': this.nodeData.fullName,
            'unit': this.canValue,
            'description': this.description,
            'mqttId': this.nodeData.mqttId,
            'keyPrefix': this.nodeData.keyPrefix,
            'sort': this.nodeData.sort,
            'attribute': {
              'din': this.nodeData.attribute.din,
              'device_version': this.nodeData.attribute.device_version, // 设备的版本号
              'device_name': this.nodeData.attribute.device_name, // 子设备名称，没有子设备时，为“”空字符串
              'force': this.force,// 是否强制
              'expression': this.expression // 计算公式
            }
          }
          service.getNode(this.nodeData.parentId).then(res => {
            if (res.type === 'subDevice') {
              data.attribute.device_name = res.name
              service.getNode(res.parentId).then(Response => {
                data.attribute.device_version = Response.attribute.version
                this.updatePointData(data)
              })
            } else {
              data.attribute.device_version = res.attribute.version
              this.updatePointData(data)
            }
          }).catch(err => {
            this.loading = false
            this.$Message.error(err.message)
          })
        }
      } else {
        let type = this.pointData.type
        let finalType = ''
        switch (type) {
          case 'Analog':
            finalType = 'value_Analog'
            break
          case 'Binary':
            finalType = 'value_Binary'
            break
          case 'Multistate':
            finalType = 'value_Multistate'
            break
          case 'String':
            finalType = 'value_String'
            break
          default:
            break
        }
        let uploadData = {
          'name': this.name, // 点位名称
          'type': finalType, // 点位类型,八种中的一种
          'parentId': this.nodeData.id,
          'value': this.value,
          'unit': this.canValue,
          'fullName': this.nodeData.fullName,
          'description': this.description,
          'mqttId': this.nodeData.mqttId,
          'keyPrefix': this.nodeData.keyPrefix,
          'sort': this.nodeData.sort,
          'attribute': {
            'alarmState': '正常', // 报警状态
            'settableValue': this.canValue, // 可设置的值或单位
            pointType: true,
            'realTime': false,
            'expression': this.expression
          }
        }
        uploadData.description = this.description
        service.newAddPoint(uploadData).then(res => {
          this.loading = false
          this.$Message.success('新建成功')
        }).catch(err => {
          this.loading = false
          this.$Message.error(err.message)
        })
      }
      this.close()
    },
    updatePointData(data) {
      service.renamePoint(data).then(res => {
        this.loading = false
        this.$Message.success('修改成功')
      }).catch(err => {
        this.loading = false
        this.$Message.error(err.message)
      })
    }
  }
}
</script>
<style scoped>
.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 45%;
  float: left;
  margin-right: 20px;
}

fieldset {
  padding: 10px;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.tit {
  color: #ffffff;
}

.txt {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/point/point.vue